import { useState, useEffect } from "react";
import SearchBar from "../../../component/SearchBar/SearchBar";
import { Table } from "reactstrap";
import * as actions from "./../../../Redux/Actions";
import useLoadingIndicator from "../../../component/Loader/Loader";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import "./HandleOnboarding.scss";
import {
  Strings,
  activityTrackerHeader,
  certficationsTableHeader,
  educationalTableHeader,
  requiredFeild,
} from "../../../constant/Strings";
import Button from "../../../component/Buttons/Button";
import ModalComponents from "../../../component/ModalComponent/ModalComponent";
import AddQualification from "../../EmployeeDb/EmployeeDetails/DbSideBarPages/Qualification/AddQualification";
import { icons } from "../../../assets";
import DeleteQualification from "../../EmployeeDb/EmployeeDetails/DbSideBarPages/Qualification/DeleteQualification";
import EditQualification from "../../EmployeeDb/EmployeeDetails/DbSideBarPages/Qualification/EditQualification";
import AddCertifications from "../../EmployeeDb/EmployeeDetails/DbSideBarPages/Certifications/AddCertifications";
import DeleteCertifications from "../../EmployeeDb/EmployeeDetails/DbSideBarPages/Certifications/DeleteCertifications";
import EditCertifications from "../../EmployeeDb/EmployeeDetails/DbSideBarPages/Certifications/EditCertifications";
import { float } from "html2canvas/dist/types/css/property-descriptors/float";
import TaskCard from "../TaskCard/TaskCard";
import AddTask from "../TaskDetails/AddTask";

const HandleOnboarding = (props: any) => {
  const { status } = props;
  const userLogin: any = localStorage.getItem("login");
  const loginId = JSON.parse(userLogin)?.id;
  const role = localStorage.getItem("role");
  const selectedId = localStorage.getItem("selectedId");
  const [info, setInfo] = useState([]);
  const dispatchQualifications = useDispatch();
  const { loadingComponent, showLoadingIndicator, hideLoadingIndicator } =
    useLoadingIndicator();
  const [filters, setFilters] = useState({ page: 1, limit: 10, activityType: 'Onboarding' });
  const [qualifications, setQualifications] = useState({
    id: "",
    qualification: "",
    branch: "",
    institute: "",
    board: "",
    year: "",
    marks: "",
    qualificationImage: "",
  });
  const { educational_information_heading, certficationsTitle } = Strings;
  const { edit_blue_icon, delete_icon } = icons;
  const { required } = requiredFeild;
  const [deleteId, setDeleteId] = useState("");
  const [showAddQualifications, setShowAddQualifications] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [onclickSearch, setOnclickSearch] = useState(false);
  const [ShowAddTask, setShowAddTask] = useState(false);

  const handleAddQualifications = () => {
    setShowAddQualifications(true);
  };
  const hideAddQualifications = () => {
    setShowAddQualifications(false);
  };
  const [showEditQualifications, setShowEditQualifications] = useState(false);
  const [showDeleteQualifications, setShowDeleteQualifications] =
    useState(false);
  const handleEditQualifications = (
    id: any,
    qualification: any,
    branch: string,
    institute: string,
    board: string,
    year: string,
    marks: any,
    qualificationImage: any
  ) => {
    setQualifications({
      id: id,
      qualification: qualification,
      branch: branch,
      institute: institute,
      board: board,
      year: year,
      marks: marks,
      qualificationImage: qualificationImage,
    });
    setShowEditQualifications(true);
  };
  const addEmployeeQualification = useSelector(
    (state: any) => state.employeeReducer.addEmployeeQualification
  );
  const deleteEmployeeQualification = useSelector(
    (state: any) => state.employeeReducer.deleteEmployeeQualification
  );
  const editEmployeeQualification = useSelector(
    (state: any) => state.employeeReducer.editEmployeeQualification
  );
  useEffect(() => {
    showLoadingIndicator();
    dispatchQualifications(actions.getEmployeeQualificationAction());
     setTimeout(() => {
      hideLoadingIndicator();
    }, 1000);
  }, [
    addEmployeeQualification,
    deleteEmployeeQualification,
    editEmployeeQualification,
    selectedId,
  ]);
  const hideEditQualifications = () => {
    setShowEditQualifications(false);
  };

  const handleDeleteQualifications = (id: any) => {
    setDeleteId(id);
    setShowDeleteQualifications(true);
  };
  const hideDeleteQualifications = () => {
    setShowDeleteQualifications(false);
  };

    const handleSearch = (value: any) => {
    setSearchValue(value);
    
  };
    const onSearchClicked = (value: any) => {
    setOnclickSearch(value);
  };

  const employeeQualification = useSelector(
    (state: any) => state.employeeReducer.getEmployeeQualification
  );

 
  useEffect(() => {
    if (employeeQualification) {
      if (employeeQualification.data) {
        setInfo(employeeQualification.data);
      }
    }
  }, [employeeQualification, info, selectedId]);

  const [infoCertifications, setInfoCertifications] = useState([]);
  const [certifications, setCertifications] = useState({
    id: "",
    nameOfCertification: "",
    institute: "",
    board: "",
    year: "",
    marks: "",
  });
  const [deleteIdCertifications, setDeleteIdCertifications] = useState("");

  const [showAddCertifications, setShowAddCertifications] = useState(false);
  const handleAddCertifications = () => {
    setShowAddCertifications(true);
  };
  const hideAddCertifictions = () => {
    setShowAddCertifications(false);
  };

  const [showEditCertifications, setShowEditCertifications] = useState(false);
  const handleEditCertifications = (
    id: string,
    nameOfCertification: any,
    institute: any,
    board: any,
    year: string,
    marks: string
  ) => {
    setCertifications({
      id: id,
      nameOfCertification: nameOfCertification,
      institute: institute,
      board: board,
      year: year,
      marks: marks,
    });
    setShowEditCertifications(true);
  };
  const hideEditCertifications = () => {
    setShowEditCertifications(false);
  };

  const [showDeleteCertifications, setShowDeleteCertifications] =
    useState(false);
  const handleDeleteCertifications = (id: any) => {
    setDeleteIdCertifications(id);
    setShowDeleteCertifications(true);
  };
  const hideDeleteCertifications = () => {
    setShowDeleteCertifications(false);
  };
  const addEmployeeCertifications = useSelector(
    (state: any) => state.employeeReducer.addEmployeeCertifications
  );
  const editEmployeeCertifications = useSelector(
    (state: any) => state.employeeReducer.editEmployeeCertifications
  );
  const deleteEmployeeCertifications = useSelector(
    (state: any) => state.employeeReducer.deleteEmployeeCertifications
  );

  const dispatchCertifications = useDispatch();
  useEffect(() => {
    showLoadingIndicator();
    dispatchCertifications(actions.getEmployeeCertificationsAction());
    setTimeout(() => {
      hideLoadingIndicator();
    }, 1000);
  }, [
    addEmployeeCertifications,
    editEmployeeCertifications,
    deleteEmployeeCertifications,
    selectedId,
  ]);

  const employeeCertifications = useSelector(
    (state: any) => state.employeeReducer.getEmployeeCertifications
  );

  const handleAddModalShow = () => {
    setShowAddTask(true);
  };
  const hideAddModal = () => {
    setShowAddTask(false);
  };

  useEffect(() => {
    if (employeeCertifications) {
      if (employeeCertifications.data) {
        setInfoCertifications(employeeCertifications.data);
      }
    }
  }, [employeeCertifications, infoCertifications]);
  const HRBPTask = [
  // {
  //   id: '1',
  //   taskName: ' Hire Documentation Review',
  //   activityType: 'Onboarding',
  //   status: 'Open',
  //   assignedHRBP: 'Sarah Johnson',
  //   dueDate: '2024-08-15',
  //   priority: 'High',
  //   comments: 'Need to review and complete all onboarding paperwork',
  //   createdDate: '2024-08-01',
  //   slaDays: 3,
  //   employeeId: 'EMP001',
  //   employeeName: 'John Smith',
  //   clientName: 'TechCorp Inc'
  // },
  // {
  //   id: '2',
  //   taskName: 'Q3 Performance Review Prep',
  //   activityType: 'Performance Hygiene',
  //   status: 'Pending',
  //   assignedHRBP: 'Michael Chen',
  //   dueDate: '2024-08-20',
  //   priority: 'Medium',
  //   comments: 'Gathering feedback from managers and peers',
  //   createdDate: '2024-07-25',
  //   slaDays: 7,
  //   employeeId: 'EMP002',
  //   employeeName: 'Alice Johnson',
  //   clientName: 'InnovateLab'
  // }
  {
    id: '1',
    taskName: 'Exit Interview Scheduling',
    activityType: 'Resignation',
    status: 'Open',
    assignedHRBP: 'Emily Rodriguez',
    dueDate: '2024-08-12',
    priority: 'High',
    comments: 'Schedule exit interview with departing employee',
    createdDate: '2024-08-05',
    slaDays: 2,
    employeeId: 'EMP003',
    employeeName: 'Mike Wilson',
    clientName: 'DataFlow Systems'
  },
  {
    id: '2',
    taskName: 'Team Building Event Planning',
    activityType: 'Employee Engagement',
    status: 'Closed',
    assignedHRBP: 'David Kim',
    dueDate: '2024-07-30',
    priority: 'Medium',
    comments: 'Successfully organized quarterly team building event',
    createdDate: '2024-07-01',
    completedDate: '2024-07-28',
    slaDays: 5,
    employeeId: 'EMP004',
    employeeName: 'Sarah Davis',
    clientName: 'CloudTech Solutions'
  }
  // {
  //   id: '5',
  //   taskName: 'Annual Goal Setting Workshop',
  //   activityType: 'Goal Setting',
  //   status: 'Open',
  //   assignedHRBP: 'Lisa Wang',
  //   dueDate: '2024-08-25',
  //   priority: 'High',
  //   comments: 'Prepare materials for annual goal setting session',
  //   createdDate: '2024-08-02',
  //   slaDays: 10,
  //   employeeId: 'EMP005',
  //   employeeName: 'Robert Chen',
  //   clientName: 'Global Dynamics'
  // },
  // {
  //   id: '6',
  //   taskName: 'Employee Recognition Program',
  //   activityType: 'Rewards and Recognition',
  //   status: 'Pending',
  //   assignedHRBP: 'James Taylor',
  //   dueDate: '2024-08-18',
  //   priority: 'Medium',
  //   comments: 'Implementing new peer recognition system',
  //   createdDate: '2024-07-28',
  //   slaDays: 14,
  //   employeeId: 'EMP006',
  //   employeeName: 'Lisa Martinez',
  //   clientName: 'FutureTech Inc'
  // },
  // {
  //   id: '7',
  //   taskName: 'IT System Access Setup',
  //   activityType: 'Onboarding',
  //   status: 'Closed',
  //   assignedHRBP: 'Sarah Johnson',
  //   dueDate: '2024-08-05',
  //   priority: 'Critical',
  //   comments: 'All systems access granted to new hire',
  //   createdDate: '2024-07-30',
  //   completedDate: '2024-08-03',
  //   slaDays: 1,
  //   employeeId: 'EMP007',
  //   employeeName: 'David Park',
  //   clientName: 'TechCorp Inc'
  // },
  // {
  //   id: '8',
  //   taskName: 'Performance Improvement Plan',
  //   activityType: 'Performance Hygiene',
  //   status: 'Open',
  //   assignedHRBP: 'Michael Chen',
  //   dueDate: '2024-08-22',
  //   priority: 'Critical',
  //   comments: 'Develop PIP for underperforming team member',
  //   createdDate: '2024-08-03',
  //   slaDays: 21,
  //   employeeId: 'EMP008',
  //   employeeName: 'Jennifer Liu',
  //   clientName: 'InnovateLab'
  // },
  // {
  //   id: '9',
  //   taskName: 'Knowledge Transfer Documentation',
  //   activityType: 'Resignation',
  //   status: 'Pending',
  //   assignedHRBP: 'Emily Rodriguez',
  //   dueDate: '2024-08-16',
  //   priority: 'High',
  //   comments: 'Document critical processes before employee departure',
  //   createdDate: '2024-08-06',
  //   slaDays: 5,
  //   employeeId: 'EMP009',
  //   employeeName: 'Kevin Brown',
  //   clientName: 'DataFlow Systems'
  // },
  // {
  //   id: '10',
  //   taskName: 'Pulse Survey Analysis',
  //   activityType: 'Employee Engagement',
  //   status: 'Open',
  //   assignedHRBP: 'David Kim',
  //   dueDate: '2024-08-14',
  //   priority: 'Medium',
  //   comments: 'Analyze monthly employee satisfaction survey results',
  //   createdDate: '2024-08-01',
  //   slaDays: 7,
  //   employeeId: 'EMP010',
  //   employeeName: 'Emma Taylor',
  //   clientName: 'CloudTech Solutions'
  // }
];
  
  return (
    <>
    {/* <pre>{JSON.stringify(HRBPTask)}</pre> */}
    
      {loadingComponent()}
      <div className="educational-container">
         <div className="inseed-master-table-container mt-3">
          <div className="inseed-master-searchbar-wrapper">
            <div className="searchbar-wrapper">
                  <SearchBar
                filter={searchValue}
                setFilter={handleSearch}
                onSearchClicked={onSearchClicked}
              />
             
            </div>

            <div className="inseed-master-filter-container" style ={{width : "35%" }} >
              <select>
                <option>Filter</option>
              </select>
            </div>
              <div>
              <button type="button" onClick={handleAddModalShow} className="btn btn-sm btn-primary">Add Task</button>&nbsp;
            </div>
            <div>
              <button type="button" className="btn btn-sm btn-primary">Export</button>
            </div>
          </div>
          
        </div>
        <div className="card-div-container" style = {{ float: "left", width : "74%" }}>
          <Table className="table-conatiner" cellSpacing={2} cellPadding={20}>
            <thead className="table-head">
              <tr>
                {activityTrackerHeader.map((item, key) => (
                  <th className="table-th" key={key}>
                    {item}
                  </th>
                ))}
                {/* {/* {(status !== "Active" && status !== "Inactive") ||
                  (role &&
                    role.includes("hr") &&
                    status === "Active" &&
                    selectedId != loginId) ? (
                  <th className="table-th">Action</th>
                ) : null} */}
              </tr>
            </thead>

            <tbody className="table-body">
              {HRBPTask.map((ele: any, key) => {
                return (
                  <tr key={key}>
                    <td className="table-td">{ele.taskName}</td>
                    <td className="table-td">{ele.employeeName}</td>
                    <td className="table-td">{ele.clientName}</td>
                    <td className="table-td">{ele.activityType}</td>
                    <td className="table-td">{ele.status}</td>
                    <td className="table-td">{ele.dueDate}</td>
                    <td className="table-td">{ele.slaDays}</td>
                    <td className="table-td">{ele.priority}</td>
                    <td className="table-td">{ele.comments}</td>
                    {(status !== "Active" && status !== "Inactive") ||
                      (role &&
                        role.includes("hr") &&
                        status === "Active" &&
                        selectedId != loginId) ? (
                      <>
                        {/* <td className="table-td">
                          <div className="text-center">
                            <img
                              src={edit_blue_icon}
                              alt="edit_icon"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Edit"
                              onClick={() =>
                                handleEditQualifications(
                                  ele.id,
                                  ele.qualification,
                                  ele.branch,
                                  ele.institute,
                                  ele.board,
                                  ele.year,
                                  ele.marks,
                                  ele.qualificationImage
                                )
                              }
                              className="edit-icon"
                            />
                            <img
                              src={delete_icon}
                              alt="delete-icon"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Delete"
                              onClick={() => handleDeleteQualifications(ele.id)}
                              className="edit-icon"
                            />
                          </div>
                        </td> */}
                      </>
                    ) : (
                      <></>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>

        {/* <div className="heading-button-wrapper">
          <div>
            <h5>{certficationsTitle}</h5>
          </div>
          {(status !== "Active" && status !== "Inactive") ||
            (role &&
              role.includes("hr") &&
              status === "Active" &&
              selectedId != loginId) ? (
            <div className="btn-wrapper">
              <Button
                title="+ Add"
                onClick={handleAddCertifications}
                className="add-employee-btn add-employee-details-skills"
              />
            </div>
          ) : (
            <></>
          )}
        </div> */}
        {/* <div className="card-div-container">
          <Table className="table-conatiner" cellSpacing={2} cellPadding={20}>
            <thead className="table-head">
              <tr className="table-head">
                {certficationsTableHeader.map((ele: any) => (
                  <td className="table-td" key={ele}>
                    {ele}
                  </td>
                ))}

                {(status !== "Active" && status !== "Inactive") ||
                  (role &&
                    role.includes("hr") &&
                    status === "Active" &&
                    selectedId != loginId) ? (
                  <>
                    <td className="table-td">Action</td>
                  </>
                ) : (
                  <>{""}</>
                )}
              </tr>
            </thead>
            <tbody className="table-body">
              {infoCertifications.length > 0 &&
                infoCertifications.map((ele: any) => (
                  <tr key={ele.id}>
                    <td className="table-td">{ele.nameOfCertification}</td>
                    <td className="table-td">{ele.institute}</td>
                    <td className="table-td">{ele.board}</td>
                    <td className="table-td">{ele.year}</td>
                    <td className="table-td">{ele.marks}</td>
                    {(status !== "Active" && status !== "Inactive") ||
                      (role &&
                        role.includes("hr") &&
                        status === "Active" &&
                        selectedId != loginId) ? (
                      <>
                        <td className="table-td">
                          <div className="action-btn">
                            <img
                              src={icons.edit_blue_icon}
                              alt="edit_icon"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Edit"
                              onClick={() =>
                                handleEditCertifications(
                                  ele.id,
                                  ele.nameOfCertification,
                                  ele.institute,
                                  ele.board,
                                  ele.year,
                                  ele.marks
                                )
                              }
                              className="edit-icon"
                            />
                            <img
                              src={icons.delete_icon}
                              alt="delete-icon"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Delete"
                              onClick={() => handleDeleteCertifications(ele.id)}
                              className="edit-icon"
                            />
                          </div>
                        </td>
                      </>
                    ) : (
                      <></>
                    )}
                  </tr>
                ))}
            </tbody>
          </Table>
        </div> */}
        <TaskCard></TaskCard>
      </div>
       
      <div>
           <ModalComponents
        show={ShowAddTask}
        onHide={hideAddModal}
        title="Add Task Details"
        className="modal-lg"
      />
        <ModalComponents
          show={showAddCertifications}
          onHide={hideAddCertifictions}
          title="Add Certification & Credentials"
          modalBody={
            <AddCertifications
              showAddCertifications={handleAddCertifications}
              hideAddCertifictions={hideAddCertifictions}
            />
          }
          className="modal-lg"
        />

        <ModalComponents
          show={showEditCertifications}
          onHide={hideEditCertifications}
          title="Edit Certification & Credentials"
          modalBody={
            <EditCertifications
              id={certifications.id}
              nameOfCertification={certifications.nameOfCertification}
              institute={certifications.institute}
              board={certifications.board}
              year={certifications.year}
              marks={certifications.marks}
              hideEditCertifications={hideEditCertifications}
            />
          }
          className="modal-lg"
        />

        <ModalComponents
          show={showDeleteCertifications}
          onHide={hideDeleteCertifications}
          title="Delete Certification & Credentials"
          modalBody={
            <DeleteCertifications
              id={deleteIdCertifications}
              hideDeleteCertifications={hideDeleteCertifications}
            />
          }
          className="modal-md"
        />
      </div>

      <ModalComponents
        show={showAddQualifications}
        onHide={hideAddQualifications}
        title="Add Qualification"
        modalBody={
          <AddQualification
            showAddQualifications={handleAddQualifications}
            hideAddQualifications={hideAddQualifications}
          />
        }
        className="modal-lg"
      />

      <ModalComponents
        show={showEditQualifications}
        onHide={hideEditQualifications}
        title="Edit Qualification"
        modalBody={
          <EditQualification
            id={qualifications.id}
            qualification={qualifications.qualification}
            branch={qualifications.branch}
            institute={qualifications.institute}
            board={qualifications.board}
            year={qualifications.year}
            marks={qualifications.marks}
            qualificationImage={qualifications?.qualificationImage}
            hideEditQualifications={hideEditQualifications}
          />
        }
        className="modal-lg"
      />

      <ModalComponents
        show={showDeleteQualifications}
        onHide={hideDeleteQualifications}
        title="Delete Qualification"
        modalBody={
          <DeleteQualification
            id={deleteId}
            hideDeleteQualifications={hideDeleteQualifications}
          />
        }
        className="modal-md"
      />
    </>
  );
};

export default HandleOnboarding;
